// components/admin/main/LibraryOffersAdmin.jsx
import { useState, useEffect } from "react";
import {
  collection,
  addDoc,
  updateDoc,
  deleteDoc,
  getDocs,
  doc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../../firebase"; // шлях підкоригуй під свій проект
import css from "./LibraryOffersAdmin.module.css"; // можеш створити або замінити на свій CSS

const initialForm = {
  title: "",
  description: "",
  buttonText: "",
  linkUrl: "",
  imageUrl: "",
  order: 0,
  active: true,
};

export default function LibraryOffersAdmin() {
  const [banners, setBanners] = useState([]);
  const [form, setForm] = useState(initialForm);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);

  const bannersRef = collection(db, "libraryOffersBanners");

  const loadBanners = async () => {
    const snap = await getDocs(bannersRef);
    const list = snap.docs
      .map((d) => ({ id: d.id, ...d.data() }))
      .sort((a, b) => (a.order || 0) - (b.order || 0));
    setBanners(list);
  };

  useEffect(() => {
    loadBanners();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setSaving(true);
    try {
      const fileRef = ref(
        storage,
        `libraryOffersBanners/${Date.now()}_${file.name}`
      );
      await uploadBytes(fileRef, file);
      const url = await getDownloadURL(fileRef);
      setForm((prev) => ({ ...prev, imageUrl: url }));
    } catch (err) {
      console.error("Помилка завантаження зображення:", err);
    } finally {
      setSaving(false);
    }
  };

  const handleEdit = (banner) => {
    setEditingId(banner.id);
    setForm({
      title: banner.title || "",
      description: banner.description || "",
      buttonText: banner.buttonText || "",
      linkUrl: banner.linkUrl || "",
      imageUrl: banner.imageUrl || "",
      order: banner.order ?? 0,
      active: banner.active ?? true,
    });
  };

  const resetForm = () => {
    setForm(initialForm);
    setEditingId(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        ...form,
        order: Number(form.order) || 0,
      };

      if (editingId) {
        await updateDoc(doc(db, "libraryOffersBanners", editingId), payload);
      } else {
        await addDoc(bannersRef, payload);
      }

      await loadBanners();
      resetForm();
    } catch (err) {
      console.error("Помилка збереження банера:", err);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Видалити цей банер?")) return;
    try {
      await deleteDoc(doc(db, "libraryOffersBanners", id));
      await loadBanners();
    } catch (err) {
      console.error("Помилка видалення банера:", err);
    }
  };

  return (
    <div className={css.wrap}>
      <h2>Акційні пропозиції програми «Настав час бібліотек»</h2>

      <form onSubmit={handleSubmit} className={css.form}>
        <label>
          Заголовок банера
          <input
            name="title"
            value={form.title}
            onChange={handleChange}
            required
          />
        </label>

        <label>
          Опис
          <textarea
            name="description"
            value={form.description}
            onChange={handleChange}
            rows={4}
            required
          />
        </label>

        <label>
          Текст кнопки
          <input
            name="buttonText"
            value={form.buttonText}
            onChange={handleChange}
            placeholder="Наприклад: Дізнатися більше"
            required
          />
        </label>

        <label>
          Посилання
          <input
            name="linkUrl"
            value={form.linkUrl}
            onChange={handleChange}
            placeholder="https://..."
            required
          />
        </label>

        <label>
          Порядок відображення
          <input
            type="number"
            name="order"
            value={form.order}
            onChange={handleChange}
          />
        </label>

        <label className={css.checkboxRow}>
          <input
            type="checkbox"
            name="active"
            checked={form.active}
            onChange={handleChange}
          />
          Активний банер
        </label>

        <label>
          Картинка
          <input type="file" accept="image/*" onChange={handleImageChange} />
        </label>

        {form.imageUrl && (
          <div className={css.preview}>
            <img src={form.imageUrl} alt="Превʼю" />
          </div>
        )}

        <div className={css.buttons}>
          <button type="submit" disabled={saving}>
            {editingId ? "Зберегти зміни" : "Створити банер"}
          </button>
          {editingId && (
            <button type="button" onClick={resetForm}>
              Скасувати редагування
            </button>
          )}
        </div>
      </form>

      <h3>Список банерів</h3>
      <ul className={css.list}>
        {banners.map((b) => (
          <li key={b.id} className={css.item}>
            <div className={css.itemInfo}>
              <strong>{b.title}</strong>{" "}
              {!b.active && <span className={css.badge}>Неактивний</span>}
              <div className={css.small}>Порядок: {b.order ?? 0}</div>
              <div className={css.small}>{b.buttonText}</div>
            </div>
            {b.imageUrl && (
              <img src={b.imageUrl} alt="" className={css.thumb} />
            )}
            <div className={css.itemButtons}>
              <button type="button" onClick={() => handleEdit(b)}>
                Редагувати
              </button>
              <button type="button" onClick={() => handleDelete(b.id)}>
                Видалити
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
